import React from 'react';

import Button, { type ButtonProps } from '@atlaskit/button/new';

interface OwnProps {
	extraButtonText: string | undefined;
	extraButtonOnClick: () => void;
	extraButtonAppearance: ButtonProps['appearance'] | undefined;
	isExtraButtonDisabled: boolean | undefined;
	isSubmissionLoading: boolean | undefined;
	testId: string;
}

export const ExtraButton = ({
	extraButtonOnClick,
	extraButtonAppearance,
	isExtraButtonDisabled,
	isSubmissionLoading,
	extraButtonText,
	testId,
}: OwnProps) => {
	return (
		<Button
			testId={`${testId}-footer-extra-button`}
			onClick={extraButtonOnClick}
			appearance={extraButtonAppearance}
			isDisabled={isExtraButtonDisabled || isSubmissionLoading}
		>
			{extraButtonText}
		</Button>
	);
};
